// The admin Players page with memberships (MEMBERSHIPS_PLAN.md D47, D48) and a
// member's own "can I see the club's players" answer. The network half; request
// shapes come from utils/clubPlayers.js.
import {ref} from 'vue';
import {useHttpRequest} from '~/composables/useHttpRequest';
import {endpoints} from '~/network/endpoints';
import {giveTypeBody, playersDownloadData} from '~/utils/clubPlayers';

export function useClubPlayers() {
  const {httpRequest} = useHttpRequest();
  const pending = ref(false);
  const call = async (endpoint, body) => {
    pending.value = true;
    try {
      return await httpRequest(endpoint, body ?? {});
    } finally {
      pending.value = false;
    }
  };

  /** Tiles: players, with a membership, payment failed, applications waiting, plus the D47 setting. */
  const summary = (clubId) => httpRequest(endpoints.clubPlayers.summary(clubId), null);
  const visibility = (clubId) => httpRequest(endpoints.clubPlayers.visibility(clubId), null);
  /** D47: {playersVisibleTo: 'Everyone' | 'MembershipHolders', graceDays}. The API says "Saved". */
  const setVisibility = (clubId, playersVisibleTo, graceDays) =>
      call(endpoints.clubPlayers.setVisibility(clubId), {playersVisibleTo, graceDays: graceDays === '' || graceDays == null ? null : Number(graceDays)});
  /** Any signed-in viewer: whether they see the club's players, the grace line and the types on offer. */
  const access = (clubId) => httpRequest(endpoints.clubPlayers.access(clubId), null);
  /** Give a type to the ticked players or everyone matching the filters → {given, skipped, skippedPeople, line}. */
  const giveType = (clubId, state, options) => call(endpoints.clubPlayers.giveType(clubId), giveTypeBody(state, options));
  /** The Players list as a file, following the filters → {url, mimeType}. */
  const download = (clubId, state, options) => call(endpoints.clubPlayers.download(clubId), playersDownloadData(state, options));

  return {pending, summary, visibility, setVisibility, access, giveType, download};
}
